var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "div",
                [
                  _c("micro-app", {
                    attrs: {
                      name: "child-operation-date-query-remotebooking",
                      url:
                        _vm.$store.getters.frontEndPluginUrl +
                        "/operationDateQuery",
                      "router-mode": "pure",
                      destroy: ""
                    },
                    on: { datachange: _vm.operationDateQueryDataChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "231503",
                "is-append-query": true,
                reset: true,
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                )
              },
              on: {
                "click-more": function(value) {
                  _vm.isAdvancedQuery = value
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                defaultSearchItemsChange: function(value) {
                  _vm.defaultSearchItems = value
                }
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "1",
                        disabled: !_vm.selectedRow,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "2",
                        disabled:
                          !_vm.selectedRow ||
                          _vm.selectedRow.preverifyState === 7,
                        type: "success"
                      },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "3",
                        disabled: !_vm.selectedRow,
                        type: "primary"
                      },
                      on: { click: _vm.toCopy }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Copy")) + " ")]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        no: "addSeHandle",
                        "split-button": "",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addSeHandle()
                        },
                        command: function(p) {
                          _vm.addSeCommand = p
                          _vm.addSeHandle()
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.addSeCommand) + " "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("CargoMsg.Cargo_AddSeaBooking")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_AddSeaBooking")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t(
                                  "CargoMsg.Cargo_IntelligentDocumentRecognition"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_IntelligentDocumentRecognition"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown",
                    {
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        no: "addAeHandle",
                        "split-button": "",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addAeHandle()
                        },
                        command: function(p) {
                          _vm.addAeCommand = p
                          _vm.addAeHandle()
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.addAeCommand) + " "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("CargoMsg.Cargo_AddAirBooking")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_AddAirBooking")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t(
                                  "CargoMsg.Cargo_IntelligentDocumentRecognition"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_IntelligentDocumentRecognition"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "6", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toAdd({ lob: "RE" })
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddRailwayBooking")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "7",
                        type: "primary",
                        disabled:
                          !_vm.selectedRow ||
                          _vm.selectedRow.preverifyState === 7
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("lockJob", _vm.selectedRows)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_HoldSubmission")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "8",
                        type: "primary",
                        disabled:
                          !_vm.selectedRow ||
                          _vm.selectedRow.preverifyState === 7
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("submitJob", _vm.selectedRows)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_RemoteBooking_delete"
                          ]),
                          expression:
                            "$checkPermission(['button_RemoteBooking_delete'])"
                        }
                      ],
                      attrs: {
                        no: "9",
                        disabled:
                          !_vm.selectedRow ||
                          _vm.selectedRow.preverifyState === 7,
                        type: "danger"
                      },
                      on: { click: _vm.toDelete }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.isHc &&
                            _vm.$checkPermission([
                              "button_RemoteBooking_revoke"
                            ]),
                          expression:
                            "isHc && $checkPermission(['button_RemoteBooking_revoke'])"
                        }
                      ],
                      attrs: {
                        no: "revoke",
                        disabled:
                          !_vm.selectedRow ||
                          _vm.selectedRow.preverifyState !== 4,
                        type: "danger"
                      },
                      on: { click: _vm.toRevoke }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Invalid")))]
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _vm.view === "list"
                ? _c("cargo-ag-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "config-module": "23150101",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.finalColumnDefs,
                      "row-data": _vm.rowData,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "has-export-role": !_vm.isSalesForSzfs
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "23150101",
                  total: _vm.total,
                  page: _vm.pageNum,
                  limit: _vm.pageSize
                },
                on: {
                  "update:page": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:limit": function($event) {
                    _vm.pageSize = $event
                  },
                  pagination: function() {
                    if (_vm.total > 0) {
                      _vm.toQuery()
                    }
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }